// extracted by mini-css-extract-plugin
module.exports = {"photoSlider":"PhotoSlider_photoSlider__22sdZ"};